export default __webpack_public_path__ + "images/YY.27b6cba.png";